export enum EntityCategory {
  PRODUCT = 'PRODUCT',
  APP_REGISTRY = 'APP_REGISTRY',
  CUSTOM_APPS = 'CUSTOM_APPS',
  ANALYTICS = 'ANALYTICS',
}

export enum RoutePath {
  ENTITIES = '/entities',
  APP_REGISTRY = '/app-registry',
  CUSTOM_APPS = '/custom-apps',
  SETTINGS = '/settings',
  ACCOUNT = '/account',
  TOUR_EDITS = '/tour-edit',
  MAP_DETAILS = '/map-details',
  NETWORK_MAP_DETAILS = '/network-map-details',
  ANALYTICS = '/analytics',
}
